<template>
  <div :class="`lds-ring ${size}`">
      <div />
      <div />
      <div />
      <div />
  </div>
</template>

<script>
export default {
  name: "Spinner",
  
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function(value) {
        return ["extra-small", "small", "medium", "large"].includes(value);
      }
    }
  }
}
</script>

<style>
.lds-ring,
.lds-ring div {
  box-sizing: border-box;
}

.lds-ring {
  display: inline-block;
  position: relative;
}

.lds-ring.large {
  width: 80px;
  height: 80px;
}

.lds-ring.medium {
  width: 60px;
  height: 60px;
}

.lds-ring.small {
  width: 40px;
  height: 40px;
}

.lds-ring.extra-small {
  width: 28px;
  height: 28px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  border: 8px solid currentColor;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: currentColor transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

.lds-ring.large div {
  width: 64px;
  height: 64px;
  margin: 8px;
  border-width: 8px;
}

.lds-ring.medium div {
  width: 48px;
  height: 48px;
  margin: 6px;
  border-width: 6px;
}

.lds-ring.small div {
  width: 32px;
  height: 32px;
  margin: 4px;
  border-width: 4px;
}

.lds-ring.extra-small div {
  width: 20px;
  height: 20px;
  margin: 4px;
  border-width: 4px;
}

@keyframes lds-ring {
  0% {
      transform: rotate(0deg);
  }

  100% {
      transform: rotate(360deg);
  }
}
</style>
